import { render } from "./ProductDetail.vue?vue&type=template&id=678a8594&scoped=true&ts=true"
import script from "./ProductDetail.vue?vue&type=script&lang=ts"
export * from "./ProductDetail.vue?vue&type=script&lang=ts"

import "./ProductDetail.vue?vue&type=style&index=0&id=678a8594&lang=scss&scoped=true"
import "./ProductDetail.vue?vue&type=style&index=1&id=678a8594&lang=scss&scoped=true"
import "./ProductDetail.vue?vue&type=style&index=2&id=678a8594&lang=postcss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-678a8594"]])

export default __exports__